module.exports = __webpack_public_path__ + "files/d4a6887bfa2a418598556fc10365f5a1.svg";